import { useFormDataQuery } from '@/api/getters';
import { FormControl, FormField, FormItem } from '@/components/ui/Form';
import { Input } from '@/components/ui/Input';
import { OWNER_ACCOUNT_IS_OWNER_NAME } from '@/features/v2/summaryForms/components/CheckboxAccountIsOwner';
import { validateFirstName } from '@/features/v2/summaryForms/Validate';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const OWNER_FIRST_NAME_NAME = 'owner.first_name';

const InputFirstName = ({
  name = OWNER_FIRST_NAME_NAME,
  focused,
  setFocused,
  autoCompleteOff = false,
}: {
  name: string;
  focused: string;
  setFocused: (value: string) => void;
  autoCompleteOff?: boolean;
}) => {
  const { i18n } = useLingui();
  const { trigger, watch } = useFormContext();
  const { data } = useFormDataQuery();

  const isAccountOwner =
    !!watch(OWNER_ACCOUNT_IS_OWNER_NAME) && name === OWNER_FIRST_NAME_NAME;

  return (
    <FormField
      name={name}
      defaultValue={isAccountOwner ? data?.user?.first_name : ''}
      rules={{
        validate: (value: string) => validateFirstName(value),
      }}
      render={({ field, fieldState }) => {
        const { onChange, onBlur, ...restField } = field;
        return (
          <FormItem className="col-span-4 md:col-span-1">
            <FormControl>
              <Input
                id={field.name}
                autoComplete={autoCompleteOff ? 'none' : 'given-name'}
                label={i18n.t('Imię')}
                error={fieldState.error?.message}
                success={
                  focused !== field.name && !fieldState.error && field.value
                }
                onChange={(e) => {
                  onChange(e);
                  if (fieldState.error) {
                    trigger(field.name);
                  }
                }}
                onBlur={() => {
                  setFocused('');
                  onBlur();
                }}
                onFocus={() => setFocused(field.name)}
                {...restField}
              />
            </FormControl>
          </FormItem>
        );
      }}
    />
  );
};

export default InputFirstName;
